import React, { useContext, useEffect } from "react"
import {
  DEFAULT_SITE_DOMAINS,
  SITE_HEADER_TEXT_COLOR,
  SITE_PRIMARY_COLOR,
  SITE_TITLE,
} from "../../config/constant"
import ThemeContext from "../../context/ThemeContext"
import { publicArticlesRoutePrefix } from "../../routes"

export default function PublicKnowledgeBaseLayout({ children }) {
  const { theme } = useContext(ThemeContext)
  const { headerTextColor, primaryColor, customStyles, headerText, title } =
    theme
  const currentSiteDomain = window.location.hostname
  const isOnDefaultLandingPage =
    DEFAULT_SITE_DOMAINS.includes(currentSiteDomain) &&
    !window.location.pathname.includes(publicArticlesRoutePrefix)

  // the color of the font in the header
  const textStyles = {
    color: isOnDefaultLandingPage
      ? SITE_HEADER_TEXT_COLOR
      : headerTextColor || SITE_HEADER_TEXT_COLOR,
  }

  useEffect(() => {
    // if the user has custom styles, we create a style tag and append it to the head
    const customStyleId = "public-kb-custom-styles"
    if (customStyles) {
      if (!document.getElementById(customStyleId)) {
        const style = document.createElement("style")
        style.id = customStyleId
        style.innerHTML = customStyles
        document.head.appendChild(style)
      }
    }

    return () => {
      // remove the custom styles when the component unmounts
      const style = document.getElementById(customStyleId)
      if (style) {
        style.remove()
      }
    }
  }, [customStyles])

  return (
    <div className="kb-main-container">
      <div className="pcoded-wrapper">
        <div className="">
          <div className="pcoded-inner-content">
            {/* <!-- [ breadcrumb ] start --> */}
            <div
              className="page-header kb-header mb-n5 pb-n5 bg-container"
              style={{
                marginBottom: "-6rem!important",
                background: isOnDefaultLandingPage
                  ? SITE_PRIMARY_COLOR
                  : primaryColor || SITE_PRIMARY_COLOR,
              }}
            >
              <div className="page-block pcoded-content">
                <div className="row align-items-center">
                  <div className="col-md-12 mb-3">
                    <div className="page-header-title swal-footer mt-3 mb-5">
                      {headerText && !isOnDefaultLandingPage ? (
                        <div
                          className="mb-5"
                          style={textStyles}
                          dangerouslySetInnerHTML={{ __html: headerText }}
                        ></div>
                      ) : (
                        <>
                          <h5 className="company-name" style={textStyles}>
                            {isOnDefaultLandingPage ? SITE_TITLE : title}
                          </h5>
                          <h3
                            className="font-weight-bold mb-5 kb-title"
                            style={textStyles}
                          >
                            Public Knowledge Base
                          </h3>{" "}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- [ breadcrumb ] end --> */}

            <div className="main-body pcoded-content">
              <div className="page-wrapper">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
